import { c as _c } from "react/compiler-runtime";
import { DeleteIcon } from "@flat-ui";
import { useHasUserValidPermissionProjectLevel } from "@hooks/permission-control/use-has-user-valid-permission-project-level";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { canRemoveMember } from "@components/table/members/members-table-utils";
import { ProjectRemoveMenuButton } from "@components/table/members/project-remove-menu-button";
/** Provides a reusable "Remove member" menu option for project member tables */
export function useProjectRemoveMenuOption(t0) {
  const $ = _c(15);
  const {
    companyId,
    selectedProject
  } = t0;
  let t1;
  if ($[0] !== selectedProject) {
    t1 = {
      project: selectedProject
    };
    $[0] = selectedProject;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    canDeleteMemberFromProject
  } = useHasUserValidPermissionProjectLevel(t1);
  const {
    canDeleteMemberFromCompany
  } = useHasUserValidRoleCompanyLevel();
  const canRemoveMemberFromProject = !!selectedProject && selectedProject.archivingState !== "ARCHIVED" && canDeleteMemberFromProject;
  const hasRequiredIds = !!companyId && !!selectedProject;
  let t2;
  if ($[2] !== canDeleteMemberFromCompany || $[3] !== canRemoveMemberFromProject || $[4] !== hasRequiredIds) {
    t2 = function shouldShowProjectRemove(member) {
      return canRemoveMember({
        member,
        hasRequiredIds,
        canRemoveFromProject: canRemoveMemberFromProject,
        canDeleteFromCompany: canDeleteMemberFromCompany
      });
    };
    $[2] = canDeleteMemberFromCompany;
    $[3] = canRemoveMemberFromProject;
    $[4] = hasRequiredIds;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const shouldShowProjectRemove = t2;
  let t3;
  if ($[6] !== canDeleteMemberFromCompany || $[7] !== canRemoveMemberFromProject || $[8] !== companyId || $[9] !== selectedProject || $[10] !== shouldShowProjectRemove) {
    const getMenuOption = function getMenuOption() {
      if (!companyId || !selectedProject) {
        return [];
      }
      if (!canRemoveMemberFromProject && !canDeleteMemberFromCompany) {
        return [];
      }
      return [{
        label: "Remove member",
        Icon: DeleteIcon,
        component: (member_0, onMenuClose) => <ProjectRemoveMenuButton companyId={companyId} project={selectedProject} member={member_0} onMenuClose={onMenuClose} canRemoveFromWorkspace={canDeleteMemberFromCompany} />,
        shouldShow: shouldShowProjectRemove
      }];
    };
    t3 = getMenuOption();
    $[6] = canDeleteMemberFromCompany;
    $[7] = canRemoveMemberFromProject;
    $[8] = companyId;
    $[9] = selectedProject;
    $[10] = shouldShowProjectRemove;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== shouldShowProjectRemove || $[13] !== t3) {
    t4 = {
      projectRemoveMenuOption: t3,
      shouldShowProjectRemove
    };
    $[12] = shouldShowProjectRemove;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}